/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Builder_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"? This agent will be permanently deleted." |
*
* @param {Agent_Builder_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_delete_confirm_description = /** @type {((inputs: Agent_Builder_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" wirklich löschen? Dieser Agent wird dauerhaft gelöscht.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"? This agent will be permanently deleted.`)
});